import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';

export const useRegistryCatalogFiltersOpenDefaultEnabled = (options?: { skipIf?: boolean }) => {
  const isMobileOrTablet = useIsMobileOrTablet();
  const enabled = !isMobileOrTablet && !options?.skipIf;
  return { registryCatalogFiltersOpenDefaultEnabled: enabled };
};
